// extracted by mini-css-extract-plugin
export var absoluteWrapper = "movie-group-player-module--absolute-wrapper--eb8cb";
export var additionalMoviesHolder = "movie-group-player-module--additional-movies-holder--d3283";
export var breakThumbnail = "movie-group-player-module--breakThumbnail--547f4";
export var breakTimeBox = "movie-group-player-module--break-time-box--f7ab1";
export var breakTimeContent = "movie-group-player-module--breakTime-content--ed849";
export var movieContainer = "movie-group-player-module--movie-container--b9179";
export var movieWrapper = "movie-group-player-module--movie-wrapper--57f75";
export var pointsButtonWrapper = "movie-group-player-module--points-button-wrapper--810ff";
export var visible = "movie-group-player-module--visible--bd789";
export var wrapper = "movie-group-player-module--wrapper--5fdbd";